const FLOWERAI_CLOUD_HOST = 'https://pipo93.de:62453'

export const FLOWERAI_CLOUD_PLANT_LIST = `${FLOWERAI_CLOUD_HOST}/plants`
export const FLOWERAI_CLOUD_PLANT = `${FLOWERAI_CLOUD_HOST}/plants/:id`
export const FLOWERAI_CLOUD_ML_MODEL = `${FLOWERAI_CLOUD_HOST}/ml-models/tensorflow/v1/model.json`

export const FLOWERAI_CLOUD_DEVICE_LIST = `${FLOWERAI_CLOUD_HOST}/devices`
export const FLOWERAI_CLOUD_SENSOR = `${FLOWERAI_CLOUD_HOST}/devices/sensors/:uuid`
export const FLOWERAI_CLOUD_VALVE = `${FLOWERAI_CLOUD_HOST}/devices/valves/:uuid`



// WEBPACK FOOTER //
// ./src/constants/urls.js